export const UPDATE_TEST_STATE = 'UPDATE_TEST_STATE';
export const HANDLE_ADD_TEST = 'HANDLE_ADD_TEST';
export const ADD_TEST_FALSE = 'ADD_TEST_FALSE';
import {changeLoading} from '../../Main/modules/main'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'

import api from '../../../api'
import {browserHistory} from 'react-router'


const initialState =  {
}

export function updateTestState(key,value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var test = {...getState().test};
      test[key] = value;
      dispatch({
        type: UPDATE_TEST_STATE,
        payload: test
      });
      resolve();
    });
  }
}

export function getPatientDetail(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      api.get("/patients/" + id, {})
      .then(response => {
        var test = {...getState().test};
        test.patientDetail = response.patient;
        test.newData = {
          patientDetail : {}
        };
        dispatch({
          type : UPDATE_TEST_STATE,
          payload : test
        })
        resolve();
      }, err => {
        dispatch({
          type : UPDATE_TEST_STATE,
          payload : test
        })
        resolve();
      })
    })
  }
}


export function createPatientApi(createInstapap) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var test = {...getState().test};
      let locale = {...getState().locale};
      let translate = getTranslate(locale);
      let newTest = convertStateToFirstTestData(test.newData);
      newTest.patient = test.patientDetail._id;
      let startTime = new Date();
      dispatch(changeLoading(true));
      createExamApi(startTime,newTest,function(res){
        if(!res){
          test.popupDockDevice = true;
          dispatch({
            type : UPDATE_TEST_STATE,
            payload : test
          })
          resolve();
        }else{
          dispatch({
            type: ADD_TEST_FALSE,
            payload: true,
            message: translate('Created_exam_successfully')
          })
          browserHistory.push('/patient/' + test.patientDetail._id);
          resolve();
        }
        dispatch(changeLoading(false));
      })
    });
  }
}

function createExamApi(startTime,newTest,cb){
  let timer = Number(new Date());
  if(Number(new Date()) - startTime < 10000 ){
    api.post('/exams/instapap',newTest,true)
    .then(response => {
      if(response.status == false){
        let timePerRequest = Number(new Date()) - timer;
        if(timePerRequest >= 3000){
          return createExamApi(startTime,newTest,cb);
        }
        setTimeout(function(){
          return createExamApi(startTime,newTest,cb);
        }, 3000 - timePerRequest);
      }else{
        return cb(response);
      }
    }, err => {
      return createExamApi(startTime,newTest,cb);
    })
  }else{
    return cb(null);
  }
}


function convertStateToFirstTestData(addPatient){
  let commonKeys = ["reason_for_appt","hereditary_predis","personal_predis","pathological_predis"];
  let symp_presentKeys = ["vaginal_discharge","postcoital_bleeding","irregular_cervical","symp_present_other"];
  let observed_conditionsKeys = ["smooth","inflam","hipert","polop","nabothian_cyst","laceration","leucoplasia","suspicious_lesion","observed_conditions_other"];
  let notesKeys = ["report","physical","current_condition"];
  let data ={
    test_type : "Instapap", //PapSmear/Instapap/Colposcopy
    status : 1,// 1 - normal, 2 - very mild / mild dysplasia, etc
    test_date : new Date(),
    results_date :new Date(),
    results : [],
    files : [],
    symp_present : [],
    obs_conditions:[],
    notes : {}
  }
  Object.keys(addPatient.patientDetail).map((key,index)=>{
    if(commonKeys.indexOf(key)>-1){
      data[key]=addPatient.patientDetail[key];
    }
    if(symp_presentKeys.indexOf(key)>-1 ){
      let temp = {};
      temp = {
        name : key,
        value : addPatient.patientDetail[key]
      }
      data.symp_present.push(temp);
    }
    if(observed_conditionsKeys.indexOf(key)>-1){
      let temp = {};
      temp = {
        name : key,
        value : addPatient.patientDetail[key]
      }
      data.obs_conditions.push(temp);
    }
    if(notesKeys.indexOf(key)>-1){
      data.notes[key]=addPatient.patientDetail[key];
    }
  })
  return data;
}



export function updateNewDataState(key,value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var test = {...getState().test};
      test.newData.patientDetail[key] = value;
      dispatch({
        type: UPDATE_TEST_STATE ,
        payload: test
      });
      resolve();
    });
  }
}


const ACTION_HANDLERS = {
	[UPDATE_TEST_STATE] : (state, action) => action.payload,
  [HANDLE_ADD_TEST] : (state, action) => {
    return Object.assign({}, state, {
      message: action.message
    })
  },
  [ADD_TEST_FALSE] : (state, action) => {
    return Object.assign({}, state, {
      message: action.message
    })
  },
}
export default function counterReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}


// WEBPACK FOOTER //
// ./src/routes/Test/modules/test.js